import React from "react";
import Highlighter from "react-highlight-words";

type HighlightTextProps = {
  text: string;
  highlightText: string[];
  highlightColor?: string;
};

const HighlightText = ({
  text,
  highlightText,
  highlightColor = "var(--item-selected-bg-color)",
}: HighlightTextProps) => {
  return (
    <Highlighter
      textToHighlight={text}
      searchWords={highlightText}
      highlightStyle={{ backgroundColor: highlightColor }}
      highlightClassName="p-1"
    />
  );
};

export default HighlightText;
